import PropTypes from 'prop-types';
import React from 'react';

import MidresponsiveAd from 'components/Ad/Midresponsive';
import ErrorBoundary from 'components/ErrorBoundary';
import { TabbedContent } from 'components/TabbedContent';
import TabbedContentPanel from 'components/TabbedContent/Panel';
import OnTheShow from 'components/OnTheShow';
import { transformOnTheShowPackagesToUIProps } from 'components/OnTheShow/transform';

import Breakpoints from 'lib/Breakpoints';
import * as CustomPropTypes from 'lib/CustomPropTypes';
import { getNthPackageOfType } from 'lib/packageHelper';
import getPackagesComponentsForZone from '../getPackagesForZone';

import Grid from './Grid';
import Rail from './Rail';
import Column from './Column';

function TodayCoverTabbedLayout(props, context) {
  const { packages } = props;

  // Disable ad creation logic on the breakpoint component structure that is not displayed
  const isTabbed = Breakpoints.isSorM();

  const zone1MobileComponents = getPackagesComponentsForZone(
    1,
    packages,
    {
      ...context,
      isMobileOnlyComponent: true,
      packageAdsDisabled: !isTabbed,
    },
  );

  const zone1DesktopComponents = getPackagesComponentsForZone(
    1,
    packages,
    {
      ...context,
      applyAlternateTitleFormat: true,
      packageAdsDisabled: isTabbed,
    },
  );

  const zone2Packages = packages.filter((pkg) => pkg.zone === 2);
  const onTheShowHeaderPackage = getNthPackageOfType(zone2Packages, 'onTheShowHeader', 1) || {};
  const onTheShowVideoPlaylistPackage1 = getNthPackageOfType(zone2Packages, 'onTheShowPlaylist', 1) || {};
  const onTheShowVideoPlaylistPackage2 = getNthPackageOfType(zone2Packages, 'onTheShowPlaylist', 2) || {};

  const onTheShowComponentUIProps = transformOnTheShowPackagesToUIProps(
    onTheShowHeaderPackage,
    onTheShowVideoPlaylistPackage1,
    onTheShowVideoPlaylistPackage2,
  );

  // TODO:  Refactor this to eliminate content duplication and brittle styling rules
  // https://nbcnewsdigital.atlassian.net/browse/BENTO-13475
  return (
    <>
      <div className="today-cover-tabbed-layout">
        {/* Only displayed below l breakpoint - see css */}
        <TabbedContent>
          <TabbedContentPanel tabText="Top Stories">
            {zone1MobileComponents}
          </TabbedContentPanel>

          <TabbedContentPanel tabText="On The Show">
            <OnTheShow
              showHeading={false}
              {...onTheShowComponentUIProps}
            />
          </TabbedContentPanel>
        </TabbedContent>

        {/* Only displayed at or above l breakpoint - see css */}
        <Grid>
          <Column>
            {zone1DesktopComponents}
          </Column>
          <Rail>
            <ErrorBoundary key={`ErrorBoundary(${onTheShowHeaderPackage.id})`}>
              <OnTheShow
                {...onTheShowComponentUIProps}
              />
            </ErrorBoundary>
          </Rail>
        </Grid>
      </div>

      <MidresponsiveAd />
    </>
  );
}

TodayCoverTabbedLayout.propTypes = {
  /* eslint-disable-next-line react/forbid-prop-types */
  packages: PropTypes.array,
};

TodayCoverTabbedLayout.defaultProps = {
  packages: [],
};

TodayCoverTabbedLayout.contextTypes = {
  ...CustomPropTypes.layoutContext,
  vertical: PropTypes.string,
};

export default TodayCoverTabbedLayout;
